var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from "../Checkbox";
import PropTypes from "prop-types";
export var Switch = function (props) {
    return _jsx(Checkbox, __assign({ prefixCls: "mex-switch" }, props));
};
Switch.propTypes = {
    label: PropTypes.string,
    labelPlacement: PropTypes.oneOf(["left", "right"]),
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    indeterminate: PropTypes.bool,
};
Switch.defaultProps = {
    labelPlacement: "left",
};
export default Switch;
